var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSetting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 19.724 19.653",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-220.276 -256.026)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5f5f5f",
    d: "M232.4,267.444a11.344,11.344,0,0,0,1.488,2.458l.064-1.229-.42-.55a2.133,2.133,0,0,0,1.358,0l-.388.518.065,1.293a15.565,15.565,0,0,0,1.616-2.522,3.044,3.044,0,0,1,2.329,1.423,2.067,2.067,0,0,0-2.264,1.358,2.126,2.126,0,0,0,.323,1.94h-5.3s-1.422-.065-1.616-1.1a3.083,3.083,0,0,1,.776-2.717A2.72,2.72,0,0,1,232.4,267.444Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5f5f5f",
    d: "M234.244,261.85a2.433,2.433,0,0,1,2.393,2.652s-.129,3.169-2.328,3.233c-.024,0-.065,0-.065,0s-2.005,0-2.328-3.039C231.916,264.7,231.722,261.98,234.244,261.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    fill: "#fff",
    d: "M234.244,267.477s2-.194,2.07-2.975l-.259.259a2.618,2.618,0,0,0-.453-1.359,2.961,2.961,0,0,1-2.716,0,.353.353,0,0,0-.323.324v1.164l-.324-.129S232.433,267.218,234.244,267.477Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    fill: "#5f5f5f",
    cx: 1.811,
    cy: 1.811,
    r: 1.811,
    transform: "translate(236.378 269.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    fill: "#fff",
    d: "M237.5,270.322l-.142-.189.142-.142.189.142.425-.142.047-.283h.142l.047.283.378.189.283-.189.094.094-.142.283.142.378.283.047v.142l-.283.047-.142.378.142.283-.094.094-.236-.142-.425.189-.047.283h-.142l-.094-.283-.378-.189-.236.142-.094-.094.142-.236-.142-.378-.283-.047v-.142l.236-.047.189-.472"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    fill: "#5f5f5f",
    cx: 0.566,
    cy: 0.566,
    r: 0.566,
    transform: "translate(237.639 270.322)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    fill: "#fff",
    cx: 0.283,
    cy: 0.283,
    r: 0.283,
    transform: "translate(237.923 270.605)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5f5f5f",
    d: "M233.453,273.55h1.419v1.6a.887.887,0,0,1-.443.532H220.764a.79.79,0,0,1-.488-.576V256.558a.521.521,0,0,1,.533-.532h10.913l3.106,2.928v2.218a2.376,2.376,0,0,0-1.331-.266v-.887h-2.4s-.266-.089-.266-.266v-2.4H221.7V274.3h11.712v-.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    fill: "#5f5f5f",
    width: 5,
    height: 1,
    transform: "translate(223 260)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    fill: "#5f5f5f",
    width: 5,
    height: 1,
    transform: "translate(223 262)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    fill: "#5f5f5f",
    width: 5,
    height: 1,
    transform: "translate(223 264)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    fill: "#5f5f5f",
    width: 5,
    height: 1,
    transform: "translate(223 266)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    fill: "#5f5f5f",
    width: 5,
    height: 1,
    transform: "translate(223 268)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    fill: "#5f5f5f",
    width: 5,
    height: 1,
    transform: "translate(223 270)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/Setting.41c6b643fef001ceceec8329e84ae30c.svg";
export { ForwardRef as ReactComponent };